import React from "react";
import twHeylime from "../../assets/images/tw/tw-heylime.png";
import twLogo from "../../assets/images/tw/the-word-logo.png";

const TwHeader = () => {
  return (
    <div className="tw-header-bg">
      <div className="tw-header">
        <div className="tw-heylime">
          <img src={twHeylime} className="twHeylime" alt="" />
        </div>
        <div className="tw-logo">
          <img src={twLogo} alt="twLogo" />
        </div>
        <div></div>
      </div>
    </div>
  );
};
export default TwHeader;
